import React, { useEffect, useState, FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import firebase from "firebase/compat/app";
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import * as yup from 'yup';

//Services
import { getStudentsOfGroup } from '../../services/NewGroupService';
import { getUsers } from '../../services/UserService';
import { createGroup, updateGroup, /* deleteGroupUsers, */ getGroupById } from '../../services/GroupService';

//Components
import { Button, Container, Form, Row } from 'react-bootstrap';
import ActivityLoading from '../common/ActivityLoading';
import ActivitySelectTable from '../common/ActivitySelectTable';
import ActivityToast from '../common/ActivityToast';

//Types
import { GroupInterface, UserInterface, TableColumnInterface, TableOptionsInterface, ToastOptionsInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

const schema = yup.object().shape({
    name: yup.string().required("El campo 'Nombre' es requerido"),
    start_date: yup.string().required("El campo 'Fecha inicial' es requerido"),
    end_date: yup.string().required("El campo 'Fecha final' es requerido")
});

const defaultValues: any = {
    name: "",
    start_date: undefined,
    end_date: undefined,
    // cycle_id: "",
    // cycle_name: ""
};

interface UserListInterface {
    available: Array<UserInterface>,
    selected: Array<UserInterface>
}

const UserGroup: FC = (props: any) => {
    const { location } = props;

    const [action, setAction] = useState("create");
    const [loading, setLoading] = useState(false);
    const [userGroup, setUserGroup] = useState<GroupInterface | undefined>(undefined);
    const [userList, setUserList] = useState<UserListInterface>({ available: [], selected: [] });
    const [usersNoGroup, setUsersNoGroup] = useState<Array<UserInterface> | undefined>(undefined);
    const [usersByGroup, setUsersByGroup] = useState<Array<UserInterface> | undefined>(undefined);
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });

    const history = useHistory();

    const { control, formState, handleSubmit, setValue, watch } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });
    const { errors } = formState;

    const watchName = watch("name", false);
    const watchStartDate = watch("start_date", false);
    const watchEndDate = watch("end_date", false);

    useEffect(() => {
        setLoading(true);

        const locationSplit = location.pathname.split('/')
        if (locationSplit[2] === "edit") {
            setAction("update")
            fetchGroup(locationSplit[3]);
        } else {
            setUserGroup({} as GroupInterface);
        }

        getUsers().then((response: any) => {
            setUsersNoGroup(response as Array<UserInterface>);
        })
    }, [location])

    useEffect(() => {
        if (userGroup && userGroup.id) {
            getStudentsOfGroup(userGroup.id).then((response: any) => {
                setUsersByGroup(response as Array<UserInterface>);
            })

            setValue('name', userGroup.name ? userGroup.name : "");
            setValue('cycle_id', userGroup.cycle_id ? userGroup.cycle_id : "");
            setValue('cycle_name', userGroup.cycle_name ? userGroup.cycle_name : "");
            setValue('start_date', userGroup.start_date ? moment(userGroup.start_date.toDate()).format("YYYY-MM-DDTHH:mm") : undefined);
            setValue('end_date', userGroup.end_date ? moment(userGroup.end_date.toDate()).format("YYYY-MM-DDTHH:mm") : undefined);
        } else {
            setUsersByGroup([])
        }
    }, [userGroup, setValue])

    useEffect(() => {
        if (usersByGroup && usersNoGroup) {
            const selected: Array<any> = [];
            const available: Array<any> = [];

            usersByGroup.forEach(uByGroup => {
                selected.push({
                    id: uByGroup.id,
                    name: uByGroup.displayName ? uByGroup.displayName : "",
                    email: uByGroup.email ? uByGroup.email : ""
                });
            });

            usersNoGroup.forEach(uNoGroup => {
                const inGroup = usersByGroup.find((uByGroup) => uByGroup.id === uNoGroup.id);

                if (!inGroup)
                    available.push({
                        id: uNoGroup.id,
                        name: uNoGroup.displayName ? uNoGroup.displayName : "",
                        email: uNoGroup.email ? uNoGroup.email : ""
                    });
            });

            setUserList({ selected, available } as UserListInterface);
            setLoading(false);
        }
    }, [usersByGroup, usersNoGroup])

    const fetchGroup = (groupId: string) => {
        if (!groupId || groupId === "error") {
            setToastOptions({ open: true, message: "Ha ocurrido un error" });
            setLoading(false);
            return;
        }

        getGroupById(groupId).then((response: any) => {
            setUserGroup(response as GroupInterface);
        })
    }

    const onSubmit = (groupData: GroupInterface) => {
        setLoading(true);

        const startDateMoment = moment(groupData.start_date);
        const startDate = firebase.firestore.Timestamp.fromDate(startDateMoment.toDate());

        const endDateMoment = moment(groupData.end_date);
        const endDate = firebase.firestore.Timestamp.fromDate(endDateMoment.toDate());

        const payload: GroupInterface = {
            name: groupData.name,
            start_date: startDate,
            end_date: endDate,
            cycle_name: action === "update" ? groupData.cycle_name : "",
            cycle_id: action === "update" ? groupData.cycle_id : "",
            deleted: false
        }

        const addUsersGroup = usersByGroup ?
            userList.selected.filter((ele: UserInterface) => {
                return !usersByGroup.find((ubg: UserInterface) => ubg.id === ele.id);
            }) :
            userList.selected.filter((ele: UserInterface) => ele.id);

        if (action === "update" && userGroup) {
            const removeUsersGroup = usersByGroup ?
                userList.available.filter((ele: UserInterface) => {
                    return usersByGroup.find((ubg: UserInterface) => ubg.id === ele.id);
                }) :
                userList.available.filter((ele: UserInterface) => ele.id);

            // const addUsersGroup = groupList.selected.filter((ele: GroupInterface) => {
            //     return usersNoGroup.find((ubg) => ubg.id === ele.id);
            // })

            // const addUsersGroup = userList.selected.filter((ele: UserInterface) => ele.id);

            updateGroup(userGroup.id, payload, addUsersGroup, removeUsersGroup)
                .then((response: any) => {
                    if (response.type === "success") {
                        history.push({ pathname: `/userGroups` });
                    } else {
                        setToastOptions({ open: true, message: response.message });
                        setLoading(false);
                    }
                });
        } else {
            createGroup(payload, addUsersGroup)
                .then((response: any) => {
                    if (response.type === "success") {
                        history.push({ pathname: `/userGroups` });
                    } else {
                        setToastOptions({ open: true, message: response.message });
                        setLoading(false);
                    }
                });
        }
    }

    const handleDualSave = (data: any) => {
        setUserList(data);
    }

    const handleToastClose = (data: any) => {
        setToastOptions({ open: false, message: "" });
    }

    const tableColumns: Array<TableColumnInterface> = [
        { title: "Nombre", value: "name" },
        { title: "Email", value: "email" }
    ]

    const options: TableOptionsInterface = {
        height: 600,
        searchBy: ['name', 'email'],
        searchResultFormat: (data: any) => `${data.name} - ${data.email}`
    }

    const handleGoToUserImport = () => {
        if (action === "update" && userGroup) {
            history.push({
                pathname: `/users/importUsers`,
                state: { group: userGroup.id }
            });
        } else {
            setLoading(true);

            const startDateMoment = watchStartDate && moment(watchStartDate);
            const startDate = startDateMoment ? firebase.firestore.Timestamp.fromDate(startDateMoment.toDate()) : null;

            const endDateMoment = watchEndDate && moment(watchEndDate);
            const endDate = endDateMoment ? firebase.firestore.Timestamp.fromDate(endDateMoment.toDate()) : null;

            const payload = {
                name: watchName,
                start_date: startDate,
                end_date: endDate,
                deleted: false
            }

            createGroup(payload)
                .then((response: any) => {
                    if (response.type === "success") {
                        history.push({
                            pathname: `/users/importUsers`,
                            state: { group: response.data }
                        });
                    } else {
                        setToastOptions({ open: true, message: response.message });
                        setLoading(false);
                    }
                });
        }
    }

    // const deleteUsers = () => {
    //     deleteGroupUsers(userList.selected);
    // }

    if (loading) return <ActivityLoading />

    return (
        <Container>
            <ActivityToast {...toastOptions} onClose={handleToastClose} autohide={4000} />
            <div style={{ marginBottom: '10px' }}>
                <h1>Grupo de usuarios</h1>
            </div>
            <Button
                type="submit"
                variant="outline-primary"
                aria-label="save"
                className="return-button"
                onClick={() => history.push({ pathname: `/userGroups` })}
            >
                {`Regresar`}
            </Button>
            <form className="flex flex-col justify-center w-full" onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="cycleName">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.name?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />

                <Row xs={1} md={2}>
                    <Controller
                        name="start_date"
                        control={control}
                        render={({ field }) => (
                            <Form.Group controlId="cycleName">
                                <Form.Label>Fecha inicial</Form.Label>
                                <Form.Control
                                    {...field}
                                    type="datetime-local"
                                    isInvalid={!!errors.start_date}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors?.start_date?.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        )}
                    />

                    <Controller
                        name="end_date"
                        control={control}
                        render={({ field }) => (
                            <Form.Group controlId="cycleName">
                                <Form.Label>Fecha final</Form.Label>
                                <Form.Control
                                    {...field}
                                    type="datetime-local"
                                    isInvalid={!!errors.end_date}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors?.end_date?.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        )}
                    />
                </Row>

                <div style={{ marginBottom: '15px' }}>
                    <Button
                        disabled={!watchName}
                        variant="outline-primary"
                        style={{ marginLeft: '10px' }}
                        onClick={() => handleGoToUserImport()}
                    >
                        Importar usuarios
                    </Button>
                </div>

                <Form.Label>Usuarios</Form.Label>
                <ActivitySelectTable
                    columns={tableColumns}
                    options={options}
                    available={userList.available}
                    selected={userList.selected}
                    onSave={handleDualSave}
                />

                <Button
                    style={{ margin: "10px 0px" }}
                    type="submit"
                    variant="primary"
                    aria-label="save"
                >
                    {`Guardar grupo`}
                </Button>
            </form>
        </Container>
    )
}

export default UserGroup;
